import { useNavigate } from "react-router-dom";
import { FC } from "react";
import { KeenIcon } from "../keenicons";

interface BackButtonProps {
  customBackPath?: string; // Optional prop for overriding default back behavior
  label?: string; // Accessible name and tooltip, e.g. "Back to dashboard"
}

export const BackButton: FC<BackButtonProps> = ({ customBackPath, label }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (customBackPath) {
      navigate(customBackPath);
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      onClick={handleBack}
      className="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-md  transition-colors duration-200"
      aria-label={label ?? "back"}
      title={label}
    >
      <KeenIcon icon="arrow-left" />
    </button>
  );
};
